import getBlockIdByElement from './get-block-id-by-element';
import getBlockSettings from './get-block-settings';
import customization from '../../customization';

const getDisplayOptionsForElement = (blockNode) => {
  if (!blockNode) return [];

  const blockId = getBlockIdByElement(blockNode);
  if (!blockId) return [];

  const palette = customization.accessors.getCurrentColorPalette();
  const blockSettings = getBlockSettings(blockId, palette);
  if (!blockSettings || !blockSettings.displayOptions) return [];

  const attributes = [...blockNode.attributes];

  return blockSettings.displayOptions
    .map((option) => {
      const { attribute, id, options, type, hidden, index, toggleable } = option;
      const nodeAttribute = attributes.find((attributeItem) => attributeItem.name === attribute);
      let value = nodeAttribute ? nodeAttribute.value : null;

      if (Number.isInteger(index)) {
        const values = value.split(' ');

        value = values[index] || null;
      }

      return {
        id,
        hidden,
        attribute,
        index,
        type,
        toggleable,
        value,
        isSet: !!nodeAttribute,
        options,
      };
    })
    .filter((item) => !!item);
};

export default getDisplayOptionsForElement;
